import { showDialog } from "@nutui/nutui";
import { showToast } from "@nutui/nutui";
import "@nutui/nutui/dist/packages/notify/style/css";
import "@nutui/nutui/dist/packages/dialog/style/css";
import "@nutui/nutui/dist/packages/toast/style/css";

export const success = (message: string) => showToast.success(message);
export const info = (message: string) => showToast.text(message);
export const warning = (message: string) => showToast.warn(message);
export const error = (message: string) => showToast.fail(message);

export const alert = (
  message: string,
  title: string,
  onOk?: () => Promise<void>
) =>
  showDialog({
    title,
    content: message,
    noCancelBtn: true,
    okText: "知道了",
    onOk,
  });

export const confirm = (
  message: string,
  title: string,
  showCancelButton: boolean,
  showConfirmButton: boolean,
  cancelButtonText?: string,
  confirmButtonText?: string,
  onOk?: () => Promise<void>,
  onCancel?: () => Promise<void>
) =>
  showDialog({
    title,
    content: message,
    noOkBtn: !showConfirmButton,
    noCancelBtn: !showCancelButton,
    okText: confirmButtonText || "确定",
    cancelText: cancelButtonText || "取消",
    onOk,
    onCancel,
  });

export const showLoading = (msg: string) =>
  showToast.loading(msg, { cover: true, duration: 0 });
